export function getAudioPreferenceFromLocalstorage() {
  const savedPreference = localStorage.getItem("audioPreference");
  return savedPreference || "full" //default to full if nothing saved
}

export function setAudioPreferenceInLocalstorage(setting:string) {
  localStorage.setItem("audioPreference", setting);
}


// WEBPACK FOOTER //
// ./src/_audio/audio-localstorage-operations.js